/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* 左边的品牌列表 */
import React, { useRef, useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image } from 'Components/view-image'
import { ContextStore } from './reducer'

import { IConditionsProps, IInfoProps, ISortProps } from './interface'
import Link from 'next/link'

interface IProps {
  letters: string[]
  brands: IInfoProps[][]
}

const DEFAULT_LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export default function Brand({ letters, brands }: IProps) {
  const { state, dispatch } = React.useContext(ContextStore)
  const router = useRouter()
  const [currentLetter, setCurrentLetter] = useState('hot')
  const [currentId, setCurrentId] = useState(-1)
  function renderLetters(letters: string[]) {
    return (
      <ul className="tw-flex md:tw-flex-none">
        <li
          key={'x'}
          className={classnames(
            'brand-child md:tw-ml-2 md:tw-mr-2 brand-width',
            {
              active: currentLetter === '',
            }
          )}
          onClick={() => {
            setCurrentLetter('')
            const href = window.location.pathname
            router.push(href, href)
          }}
        >
          不限
        </li>
        <li
          key={'hot'}
          className={classnames(
            'brand-child md:tw-ml-2 md:tw-mr-2 brand-width after',
            {
              active: currentLetter === 'hot' || currentLetter === 'bg-hot',
            }
          )}
          onClick={() => {
            setCurrentLetter('hot')
          }}
        >
          热门
        </li>
        {letters.map((letter: string) => (
          <li
            key={letter}
            className={classnames('brand-child md:tw-ml-2 md:tw-mr-2 after', {
              active: letter === currentLetter,
            })}
            onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
              e.preventDefault()
              e.stopPropagation()
              sendTeaCommEvent('click_brand_initial_index', {
                initial: letter,
              })
              setCurrentLetter(letter)
            }}
          >
            {letter}
          </li>
        ))}
        <style jsx>
          {`
            ul {
              height: 46px;
            }
            .brand-child {
              display: inline-block;
              margin-top: 17px;
              padding: 4px 8px;
              cursor: pointer;
              -webkit-transition: all 0.1s ease-in-out;
              transition: all 0.1s ease-in-out;
              border-radius: 2px;
            }
            .brand-child:hover {
              background: rgba(255, 225, 0, 0.2);
            }
            li {
              position: relative;
            }
            .after.active:after {
              content: '';
              position: absolute;
              width: 0;
              height: 0;
              bottom: -15px;
              left: 50%;
              transform: translate(-50%, 0);
              border-right: 7px solid transparent;
              border-left: 7px solid transparent;
              border-bottom: 9px solid #f7f8fc;
            }
          `}
        </style>
      </ul>
    )
  }

  function renderBrands() {
    return (
      <div className="more-list-wrap">
        {brands?.map((brand: IInfoProps[], index: number) => {
          return (
            <div
              className={classnames(
                `more-list clearfix ${brand[0]?.info?.pinyin}`,
                {
                  'show-more': brand[0]?.info?.pinyin === currentLetter,
                }
              )}
              key={brand[0]?.info?.pinyin}
            >
              {brand.map((item: IInfoProps) => {
                if (item.type === 1001) {
                  return (
                    <div className="brand-wrap fl" key={item.info.brand_id}>
                      <p
                        key={item.info.brand_id}
                        className={classnames('brand-image g-one-line-text', {
                          active: item.info.brand_id === currentId,
                        })}
                        title={item.info.brand_name}
                        onClick={() => {
                          setCurrentId(item.info.brand_id)
                          sendTeaCommEvent('clk_event', {
                            event_id: 'car_select_brand',
                            brand_id: `${item.info.brand_id}`,
                            brand_name: item.info.brand_name,
                          })
                          let href = window.location.pathname
                          if (item.info.brand_id !== currentId) {
                            href += `?key=brand&param=${item.info.brand_id}&text=${item.info.brand_name}&more=${currentLetter}`
                          }
                          router.push(href, href)
                        }}
                      >
                        <Image
                          src={item.info.image_url || ''}
                          alt={item.info.brand_name}
                          width={100}
                          height={100}
                          lazy={true}
                        />
                        <span>{item.info.brand_name}</span>
                      </p>
                    </div>
                  )
                }
                return null
              })}
            </div>
          )
        })}
        <style jsx>
          {`
            .more-list {
              display: none;
              background: #f7f8fc;
              margin-top: 15px;
              margin-bottom: 10px;
              padding: 18px 0 0 12px;
            }
            .more-list.hot {
              height: 60px;
              overflow: hidden;
            }
            .show-more {
              display: block;
            }
            .hot .brand-wrap {
              width: auto;
              margin-right: 30px;
            }
            .brand-wrap {
              width: 118px;
              height: 32px;
              margin-right: 2px;
              margin-bottom: 10px;
            }
            .brand-image {
              display: inline-block;
              padding: 4px 8px;
              cursor: pointer;
              border-radius: 2px;
            }
            .brand-image:hover {
              background: rgba(255, 225, 0, 0.2);
            }
            .more-list-wrap {
              margin-right: 20px;
            }
            :global(.more-list-wrap .more-list .brand-wrap img) {
              width: 24px;
              height: 24px;
              display: inline-block;
              margin-right: 2px;
            }
          `}
        </style>
      </div>
    )
  }

  useEffect(() => {
    if (letters) {
      if (state.brand) {
        const id = state.brand[0]?.param as number
        setCurrentId(id)
        if (state.brand[0]?.more) {
          setCurrentLetter(state.brand[0]?.more)
          return
        }
        // eslint-disable-next-line no-unused-expressions
        brands?.forEach((brand: any) => {
          brand.forEach((item: any) => {
            if (item?.info?.brand_id === id) {
              setCurrentLetter(item?.info?.pinyin)
            }
          })
        })
      } else {
        setCurrentId(-1)
      }
    }
  }, [state])

  function renderDefaultBrands() {
    return (
      <div className="more-list-wrap">
        <div
          className={classnames('more-list clearfix', {
            'show-more': currentLetter === 'bg-hot',
          })}
          key="bg-hot"
        >
          {new Array(12).fill(undefined).map((item, index) => {
            return (
              <div className="brand-wrap fl" key="bg-hot">
                <p
                  key={`bg-hot${index}`}
                  className="'brand-image g-one-line-text'"
                >
                  <span className="bg-img" />
                  <span className="bg-name" />
                </p>
              </div>
            )
          })}
        </div>
        <style jsx>
          {`
            .more-list {
              display: none;
              background: #f7f8fc;
              margin-top: 15px;
              margin-bottom: 10px;
              padding: 18px 0 0 10px;
            }
            .show-more {
              display: block;
            }
            .brand-wrap {
              width: 124px;
              height: 32px;
              margin-right: 10px;
              margin-bottom: 10px;
            }
            .brand-image {
              display: inline-block;
              padding: 4px 8px;
              cursor: pointer;
            }
            .more-list-wrap {
              margin-right: 20px;
            }
            .bg-img {
              width: 24px;
              height: 24px;
              display: inline-block;
              background: #e6e8f2;
              border-radius: 50%;
              margin-right: 2px;
            }
            .bg-name {
              width: 124px;
              height: 24px;
              display: inline-block;
              background: #e6e8f2;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="item-wrap">
      <p className="name">品牌</p>
      <div className="item-list">
        {letters ? renderLetters(letters) : renderLetters(DEFAULT_LETTERS)}
        {brands ? renderBrands() : renderDefaultBrands()}
      </div>
    </div>
  )
}
